export const PARIS_LAT = 48.85;
export const PARIS_LNG = 2.34;
